import React from 'react';
import { observer } from 'mobx-react';
import cn from 'classnames';
import { sortingTypeNames } from '../../../../constants';
import { useStores } from 'stores';
import styles from './Sorting.module.scss';

const Sorting = ({ onFilterChange }) => {
  const { lotStore } = useStores();
  const { sortingFlag } = lotStore.filters;
  const { isNewest, isOldest, isMostCheap, isMostExpensive } = sortingTypeNames;

  const isDateSortingActive = sortingFlag === isNewest || sortingFlag === isOldest;
  const isPriceSortingActive = !isDateSortingActive;

  const filterChangeHandler = value => {
    onFilterChange([{ name: 'sortingFlag', value }]);
  };

  const sortByDate = () => {
    if (sortingFlag === isNewest) {
      filterChangeHandler(isOldest);
    } else {
      filterChangeHandler(isNewest);
    }
  };

  const sortByPrice = () => {
    if (sortingFlag === isMostCheap) {
      filterChangeHandler(isMostExpensive);
    } else {
      filterChangeHandler(isMostCheap);
    }
  };

  const classSwitcher = (order, active) => {
    if (active) {
      return order ? styles.bns3_asc_order_active : styles.bns3_desc_order_active;
    }
    return order ? styles.bns3_asc_order : styles.bns3_desc_order;
  };

  const sortButton = (order, active, title, handler) => (
    <button className={cn(styles.bns3_sorting_button, classSwitcher(order, active))} type="button" onClick={handler}>
      <span>{title}</span>
    </button>
  );

  return (
    <>
      {sortButton(sortingFlag === isOldest, isDateSortingActive, 'Date', sortByDate)}
      {sortButton(sortingFlag === isMostCheap, isPriceSortingActive, 'Price', sortByPrice)}
    </>
  );
};

export default observer(Sorting);
